import { useEffect, useState } from 'react';

export function useLotTimer({
  startsAt,
  endsAt,
}: {
  startsAt?: string;
  endsAt?: string;
}) {
  const [now, setNow] = useState(Date.now());
  const starts = Date.parse(startsAt || '') || now;
  const ends = Date.parse(endsAt || '') || now;
  const isStarted = startsAt ? now > starts : false;
  const isEnded = endsAt ? now > ends : false;
  const isLive = isStarted && !isEnded;
  const startsIn = starts - now;
  const endsIn = ends - now;

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
      if (isEnded) {
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isStarted, isEnded, isLive, startsIn, endsIn };
}
